import { Component } from '@verndale/core';

class SectionNavigation extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.horizontalScrollToActive();
  }

  setupDefaults() {
    this.dom = {
      linkList: this.el.querySelector(
        '.section-navigation__list'
      ) as HTMLElement,
      links: this.el.querySelectorAll('.section-navigation__link'),
      activeLink: this.el.querySelector(
        '.section-navigation__link.active'
      ) as HTMLElement
    };
  }

  addListeners() {
    (this.dom.links as NodeList)?.forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick(e: Event) {
    const target = e.target as HTMLElement;

    target.classList.add('active');
    (this.dom.activeLink as HTMLElement)?.classList.remove('active');
    this.dom.activeLink = target;
  }

  horizontalScrollToActive() {
    const activeLink = this.dom.activeLink as HTMLElement;
    const scrollContainer = this.dom.linkList as HTMLElement;

    if (
      !activeLink ||
      !scrollContainer ||
      activeLink === (this.dom.links as NodeListOf<HTMLElement>).item(0)
    )
      return;

    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const activeLinkRect = activeLink.getBoundingClientRect();
    const scrollLeft = activeLinkRect.left - scrollContainerRect.left;

    scrollContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }
}

export default SectionNavigation;
